import React, { useEffect, useState } from "react";
import {
  FaSave,
  FaLock,
  FaFileAlt,
  FaInfoCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaCalendarAlt,
} from "react-icons/fa";
import { contentAdd } from "../../api/endpoints"; // ✅ naam update hua
import PageHeader from "../../components/PageHeader";
// import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  const [loading, setLoading] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupTitle, setPopupTitle] = useState("");
  const [policyData, setPolicyData] = useState({
    title: "",
    content: "",
    type: "PRIVACY_POLICY",
    isActive: true,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPolicyData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTypeChange = (e) => {
    setPolicyData((prev) => ({
      ...prev,
      type: e.target.value,
    }));
  };

  const showPopup = (title, message, type = "success") => {
    setPopupTitle(title);
    setPopupMessage(message);
    if (type === "success") {
      setShowSuccessPopup(true);
      setShowErrorPopup(false);
    } else {
      setShowErrorPopup(true);
      setShowSuccessPopup(false);
    }

    setTimeout(() => {
      closePopup();
    }, 5000);
  };

  const closePopup = () => {
    setShowSuccessPopup(false);
    setShowErrorPopup(false);
  };

  const handleSavePolicy = async () => {
    // Validation
    if (!policyData.title.trim()) {
      showPopup("Validation Error", "Please enter policy title", "error");
      return;
    }

    if (!policyData.content.trim()) {
      showPopup("Validation Error", "Please enter policy content", "error");
      return;
    }

    if (!policyData.type) {
      showPopup("Validation Error", "Please select policy type", "error");
      return;
    }

    try {
      setLoading(true);

      // ⚠️ sirf wahi fields bhejein jo backend ContentPage model support karta hai
      const data = {
        type: policyData.type,
        title: policyData.title,
        content: policyData.content,
        isActive: policyData.isActive,
      };

      const res = await contentAdd(data); // ✅ function call update hua

      if (res.success) {
        showPopup(
          "Success",
          res.message || "Privacy policy added successfully!",
          "success"
        );
        // Reset form after success
        setPolicyData({
          title: "",
          content: "",
          type: "PRIVACY_POLICY",
          isActive: true,
        });
      } else {
        showPopup("Error", res.message || "Failed to add policy", "error");
      }
    } catch (err) {
      console.error("Error adding privacy policy:", err);
      showPopup(
        "Error",
        err?.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const getTypeLabel = (type) => {
    const types = {
      PRIVACY_POLICY: "Privacy Policy",
      TERMS_CONDITIONS: "Terms & Conditions",
      ABOUT_US: "About Us",
    };
    return types[type] || type;
  };

  return (
    <div className="privacy-policy-page lead-page">
      <div className="row">
        <div className="col-lg-12">
          <PageHeader
            title="Add Privacy Policy"
            subtitle="Add new privacy policy, terms & conditions, or about us content"
          />

          <div className="row">
            <div className="col-lg-12">
              <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body">
                  <h5 className="fw-bold mb-4">Add New Policy</h5>

                  <div className="row">
                    {/* Policy Type */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Policy Type
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={policyData.type}
                        onChange={handleTypeChange}
                      >
                        <option value="PRIVACY_POLICY">Privacy Policy</option>
                        <option value="TERMS_CONDITIONS">
                          Terms & Conditions
                        </option>
                        <option value="ABOUT_US">About Us</option>
                      </select>
                    </div>

                    {/* Title */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Title
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={policyData.title || ""}
                        onChange={handleInputChange}
                        placeholder="Enter policy title"
                      />
                    </div>

                    {/* Active Status */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">Status</label>
                      <div className="form-check form-switch mt-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="isActive"
                          checked={
                            policyData.isActive !== undefined
                              ? policyData.isActive
                              : true
                          }
                          onChange={(e) =>
                            setPolicyData((prev) => ({
                              ...prev,
                              isActive: e.target.checked,
                            }))
                          }
                          style={{ width: "3em", height: "1.5em" }}
                        />
                        <label className="form-check-label ms-2">
                          <span
                            className={`badge ${
                              policyData.isActive ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {policyData.isActive ? "Active" : "Inactive"}
                          </span>
                        </label>
                      </div>
                    </div>

                    {/* Content with Textarea */}
                    <div className="col-md-12 mb-3">
                      <label className="form-label fw-semibold">
                        Content
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        name="content"
                        value={policyData.content || ""}
                        onChange={handleInputChange}
                        rows="12"
                        placeholder="Enter policy content here..."
                      />
                      <small className="text-muted">
                        You can use HTML tags for formatting (e.g.,
                        &lt;b&gt;bold&lt;/b&gt;, &lt;i&gt;italic&lt;/i&gt;,
                        &lt;ul&gt;lists&lt;/ul&gt;)
                      </small>
                    </div>

                    {/* Action Buttons */}
                    <div className="col-md-12">
                      <div className="d-flex gap-2 justify-content-end">
                        <button
                          className="btn btn-secondary"
                          onClick={() => {
                            setPolicyData({
                              title: "",
                              content: "",
                              type: "PRIVACY_POLICY",
                              isActive: true,
                            });
                          }}
                          disabled={loading}
                        >
                          Reset
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={handleSavePolicy}
                          disabled={loading}
                        >
                          <FaSave className="me-2" />
                          {loading ? "Saving..." : "Add Policy"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div
            className="popup-container popup-success"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popup-icon">
              <FaCheckCircle className="text-success" />
            </div>
            <h3 className="popup-title">{popupTitle}</h3>
            <p className="popup-message">{popupMessage}</p>
            <button className="popup-btn btn-success" onClick={closePopup}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* Error Popup */}
      {showErrorPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div
            className="popup-container popup-error"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popup-icon">
              <FaTimesCircle className="text-danger" />
            </div>
            <h3 className="popup-title">{popupTitle}</h3>
            <p className="popup-message">{popupMessage}</p>
            <button className="popup-btn btn-danger" onClick={closePopup}>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrivacyPolicy;